/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

import "./RateProduct.scss";
import backButton from "./left_arrow.png";
import closeButton from "./close_button.png";
import loading from "./loading-inverse.gif";
import { StarsRating } from "./StarsRating";

export function RateSeller(props) {
  const { t } = useTranslation();
  const { show, customer, seller, orderId } = props;
  const onHideProps = props.onHide;
  const onComplete = props.onComplete;
  const { modal } = props;

  const [rating, setRating] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [text, setText] = useState("");
  const starsRef = useRef();

  useEffect(() => {
    if (!show) {
      starsRef && starsRef.current && starsRef.current.clear();
      setRating(0);
      setText("");
    } else if (seller?.review?.rating) {
      starsRef && starsRef.current && starsRef.current.setRating(seller.review.rating);
      setRating(seller.review.rating);
    }
  }, [show]);

  const onHide = () => {
    if (window.confirm(t("confirm_cancel"))) onHideProps();
  };

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    if (!rating || isLoading) return;

    setIsLoading(true);

    try {
      const payload = {
        orderId,
        sellerId: seller.sellerId,
        rating,
        text,
        verificationTokenId: seller.verificationTokenIds?.[0] ?? null,
        source: "web",
      };

      const result = await axios.post(
        `${process.env.REACT_APP_API_URL}/${customer}/seller-reviews`,
        payload
      );

      if (result && result.data) {
        if (onComplete) onComplete();
      }
    } catch (err) {
      // swallow and let user retry
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {modal && (
        <div
          className={`rate-product-overlay ${show ? "show" : ""}`}
          onClick={() => {
            onHide();
          }}
        ></div>
      )}
      <div className={`rate-product ${modal ? "modal" : ""} ${show || !modal ? "show" : ""}`}>
        {modal && (
          <>
            <button
              className="back-button"
              onClick={() => {
                onHide();
              }}
            >
              <img alt={t("alt.back")} src={backButton} />
            </button>
            <button
              className="close-button"
              onClick={() => {
                onHide();
              }}
            >
              <img alt={t("alt.close")} src={closeButton} />
            </button>
          </>
        )}

        {seller && (
          <div className="step1">
            <div className="product-details">
              <div className="product-name">{seller.sellerName}</div>
            </div>

            <form className="form-review" onSubmit={handleSubmit}>
              <div className="label">{t("rating_label")}</div>
              <StarsRating
                enabled={true}
                ref={starsRef}
                onChange={(value) => setRating(value)}
              />

              <div className="label">{t("comment_label_seller") || "Tell us about your experience with the seller"}</div>
              <div className="text-container">
                <textarea
                  className="review-text"
                  value={text}
                  onChange={(evt) => setText(evt.target.value)}
                ></textarea>
              </div>

              <button type="submit" className="button" disabled={!rating || isLoading}>
                {t("submit_review")} {isLoading && <img alt={t("alt.loading")} src={loading} />}
              </button>
            </form>
          </div>
        )}
      </div>
    </>
  );
}

